import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import { UserContext } from "context/userProvider";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import {
  modelOption,
  colperOption,
  acr100Option,
} from "assets/data/deviceModel";
import "scss/screens/deviceData/pairDevice.scss";
import PairDeviceModal from "components/modals/deviceData/pairDeviceModal";
import Swal from "sweetalert2";


export default class PairDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      serialSearch: null,
      iotSearch: null,
      modelSearch: null,
      motorSearch: null,
      deviceList: [],
      deviceDetail: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      detailModal: false,
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });
  setDetailModal = () =>
    this.setState({ detailModal: !this.state.detailModal });

  async componentDidMount() {
    const { masterClpSerials, masterDeviceSerials } = this.context;

    this.startLoading();
    await masterClpSerials({ serial: null });
    await masterDeviceSerials({ serial: "" });
    await this.setDeviceData({ name: null, level: -1 });
    this.stopLoading();
  }

  setDeviceData = async (data) => {
    const { getAllLink } = this.context;
    await getAllLink(data);
    this.setState({
      deviceList: this.context.allDevicesList.slice(
        this.state.begin,
        this.state.end
      ),
    });
    console.log("deviceList", this.state.deviceList);
    console.log("searchName", this.state.serialSearch);
    
    if (this.state.serialSearch != null) {
      this.setState((prevState) => ({
        deviceList: this.context.allDevicesList.filter(dev => dev.name === prevState.serialSearch)
      }), () => {
        console.log("deviceList", this.state.deviceList);
      });
    }

    if (this.state.iotSearch != null) {
      this.setState((prevState) => ({
        deviceList: this.context.allDevicesList.filter(dev => dev.iotSerial === prevState.iotSearch)
      }), () => {
        console.log("deviceList", this.state.deviceList);
      });
    }

    if (this.state.modelSearch != null) {
      this.setState((prevState) => ({
        deviceList: this.context.allDevicesList.filter(dev => dev.model === prevState.modelSearch)
      }), () => {
        console.log("deviceList", this.state.deviceList);
      });
    }

    if (this.state.motorSearch != null) {
      this.setState((prevState) => ({
        deviceList: this.context.allDevicesList.filter(dev => dev.motor === prevState.motorSearch)
      }), () => {
        console.log("deviceList", this.state.deviceList);
      });
    }
  };

  getClpMember = async () => {
    const clpMemberList = await this.context.getClpMembers();
    console.log("clpMemberList", clpMemberList);
    // this.setState({ clpMemberList: clpMemberList });
    return clpMemberList;
  };

  alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    });
  };

  onPairDevice = async () => {
    const { serialSearch, iotSearch, modelSearch, motorSearch } = this.state;
    const { mappingDeviceModel, masterClpSerials, masterDeviceSerials } =
      this.context;
    if (
      serialSearch === "" ||
      iotSearch === "" ||
      modelSearch === "" ||
      motorSearch === ""
    ) {
      this.alertDialog(
        "Error!",
        "กรุณากรอกข้อมูลในการผูกข้อมูลให้ครบถ้วน",
        "error"
      );
    } else {
      let data = {
        deviceSerial: iotSearch,
        model: modelSearch,
        clpSerial: serialSearch,
        motor: motorSearch,
      };

      let result = await mappingDeviceModel(data);

      if (result?.result === "success") {
        await masterClpSerials({ serial: null });
        await masterDeviceSerials({ serial: "" });
        await this.setDeviceData({ name: null, level: -1 });
        await this.alertDialog("Success!", "`ผูกข้อมูลสำเร็จ`", "success");
      } else {
        this.alertDialog(
          "Error!",
          result?.result === "fail"
            ? "ผูกข้อมูลไม่สำเร็จ"
            : `มีการผูกข้อมูล ${serialSearch} แล้ว`,
          "error"
        );
      }
    }
  };

  chkBefoeDalete = async (name) => {
    let MemberList;
    this.getClpMember().then((result) => {                         
      MemberList = result;
      const chkMember = MemberList.filter((member) => member.clp_serial === name);
      
      if (chkMember.length > 0) {
        return this.alertDialog("พบปัญหา!", "หมายเลขเครื่อง" + " " + name + " " +
          "ได้มีการผูกข้อมูลเครื่องไว้ที่ User" + " " + "[" + chkMember[0].username + "]" + " " + "กรุณาทำการยกเลิกก่อนลบข้อมูลได้", "warning");
      }
      else {
        this.deleteDeviceModel(name);
      }
    });
  };

  deleteDeviceModel = async (name) => {
    const { deleteDeviceModel } = this.context;
    const data = {
      clpSerial: name,
    };
    const formData = new FormData()
    formData.append("data", JSON.stringify(data));

    let result = await deleteDeviceModel(data);
    if (result?.result === "success") {
      this.setDeviceData({ name: null, level: -1 });
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    }
  };

  createDeviceData = () => {
    const { clpSerialList, deviceSerialList } = this.context;
    const { serialSearch, iotSearch, modelSearch, motorSearch } = this.state;
    const serialOptions = clpSerialList?.map((serial) => ({
      key: serial.serial,
      value: serial.serial,
      text: serial.serial,
    }));
    const iotOptions = deviceSerialList?.map((serial) => ({
      key: serial.serial,
      value: serial.serial,
      text: serial.serial,
    }));
    const modelOptions = modelOption.map((model) => ({
      key: model,
      value: model,
      text: model,
    }));
    const colperOptions = colperOption.map((motor) => ({
      key: motor,
      value: motor,
      text: motor,
    }));
    const acrOptions = acr100Option.map((model) => ({
      key: model,
      value: model,
      text: model,
    }));
    return (
      <div className="device">
        <div className="device-search">
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Select}
                options={serialOptions}
                placeholder="หมายเลขเครื่องจักร"
                value={serialSearch}
                search
                onChange={(e, { value }) =>
                  this.setState({ serialSearch: value })
                }
              />
              <Form.Field
                control={Select}
                options={iotOptions}
                placeholder="หมายเลขอุปกรณ์"
                value={iotSearch}
                search
                onChange={(e, { value }) => this.setState({ iotSearch: value })}
              />
              <Form.Field
                control={Select}
                options={modelOptions}
                placeholder="รุ่นของเครื่องจักร"
                value={modelSearch}
                onChange={(e, { value }) =>
                  this.setState({ modelSearch: value })
                }
              />
              <Form.Field
                control={Select}
                options={
                  this.state.modelSearch === "ACR-100PLUS" ? acrOptions : colperOptions
                }
                placeholder="มอเตอร์ของเครื่องจักร"
                value={motorSearch}
                onChange={(e, { value }) =>
                  this.setState({ motorSearch: value })
                }
              />

              <Button
                onClick={() => {
                  this.setDeviceData({ name: -1, level: -1 });
                  this.setState({
                    serialSearch: null,
                    iotSearch: null,
                    modelSearch: null,
                    motorSearch: null,
                    level: -1,
                    begin: 0,
                    end: 10,
                    activePage: 1,
                  });
                }}
              > รีเซต
              </Button>

              <Button
                color="blue"
                onClick={() => {
                  if (this.state.serialSearch) {
                    this.setDeviceData({ name: this.state.serialSearch });
                  }
                  else if (this.state.iotSearch) {
                    this.setDeviceData({ name: this.state.iotSearch });
                  }
                  else if (this.state.modelSearch) {
                    this.setDeviceData({ name: this.state.modelSearch });
                  }
                  else if (this.state.motorSearch) {
                    this.setDeviceData({ name: this.state.motorSearch });
                  }
                  this.setState({
                    begin: 0,
                    end: 10,
                    activePage: 1,
                  });
                }}
              >
                ค้นหา
              </Button>
            </Form.Group>
          </Form>           
        </div>
        <div className="device-button" onClick={() => this.onPairDevice()}>
          <Button color="green">ยืนยันการผูกข้อมูล</Button>   
        </div>
      </div>
    );
  };

  createDeviceTable = () => {
    const { deviceList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>หมายเลขอุปกรณ์ IoT</Table.HeaderCell>
            <Table.HeaderCell>รุ่นเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>รุ่นมอเตอร์ไฟฟ้า</Table.HeaderCell>
            <Table.HeaderCell>แสดงข้อมูลการผูกเครื่อง</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {deviceList != null &&
            deviceList?.map((device, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>{device.name}</Table.Cell>
                <Table.Cell>{device.iotSerial}</Table.Cell>
                <Table.Cell>{device.model}</Table.Cell>
                <Table.Cell>{device.motor}</Table.Cell>
                <Table.Cell>
                  <Button
                    color="twitter"
                    onClick={() => {
                      this.setDetailModal();
                      this.setState({ deviceDetail: device });
                    }}
                  >
                    <Icon name="file alternate outline" />
                    รายละเอียด
                  </Button>
                </Table.Cell>
                <Table.Cell><Button color="red"
                  onClick={() => this.chkBefoeDalete(device.name)}>
                  ลบข้อมูล</Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { allDevicesList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      deviceList: [...allDevicesList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize, detailModal, deviceDetail } =
      this.state;
    return (
      <div className="pairDevice">
        <LetterLoading isOpen={isLoading} />
        <Navigation />
        <Sidebar tabActive="deviceData" reports="pairDevice" />

        <PairDeviceModal
          isOpen={detailModal}
          data={deviceDetail}
          isClose={this.setDetailModal}
        />

        <div className="pairDevice-content">
          <h2>การผูกข้อมูล</h2>
          <hr />

          <div className="pairDevice-content-search">
            {this.createDeviceData()}
          </div>

          <div className="pairDevice-content-table">
            {this.createDeviceTable()}
          </div>
          <div className="pairDevice-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.allDevicesList?.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

PairDevice.contextType = DeviceContext;
